import { render, staticRenderFns } from "./FormGeral.vue?vue&type=template&id=2e9d6a5c"
import script from "./FormGeral.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormGeral.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports